import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowUpRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsletterForm({ source = "footer" }) {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !email.includes("@")) {
      toast.error("Enter a valid email");
      return;
    }
    try {
      setSending(true);
      await axios.post(`${API}/newsletter`, { email: email.trim(), source });
      setDone(true);
      toast.success("Subscribed. Look for our next dispatch.");
      setEmail("");
    } catch (err) {
      const status = err?.response?.status;
      if (status === 409) toast.error("You're already subscribed.");
      else toast.error("Unable to subscribe. Try again.");
    } finally {
      setSending(false);
    }
  };

  if (done) {
    return (
      <div className="font-grotesk text-sm text-white/80" data-testid="newsletter-done">
        You're on the list. We send a considered dispatch quarterly — no spam.
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="flex items-end gap-3" data-testid="newsletter-form">
      <div className="flex-1 relative pt-4">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@studio.com"
          data-testid="newsletter-email"
          className="w-full bg-transparent border-b border-white/30 focus:border-white outline-none py-2 text-sm font-grotesk placeholder:text-white/40"
          required
        />
      </div>
      <button
        type="submit"
        disabled={sending}
        className="btn-sharp"
        style={{ background: "#FAF9F6", color: "#1A1A1A" }}
        data-testid="newsletter-submit"
      >
        <span>{sending ? "…" : "Subscribe"}</span>
        <ArrowUpRight className="w-4 h-4" />
      </button>
    </form>
  );
}
